module.exports = {
  // 范 172.16.2.199
  // baseUrl: 'http://172.16.2.199:8082/',
  // 光明 172.16.3.130   route add 172.16.3.130 mask 255.255.255.255 192.168.0.43
  // baseUrl: 'http://172.16.3.130:8082/',
  // 吕：105，刚：108，范：30，强：125，海军：47，程：123
  // 本地环境
  baseUrl: 'http://192.168.0.108:8082/',
  imageBaseUrl: 'http://192.168.0.131:19000/application',
  // 正式环境
  // baseUrl: 'https://server.qingguangtech.com/',
  // imageBaseUrl: 'https://src.qingguangtech.com/application',
  // 测试环境
  // baseUrl: 'http://58.220.10.222:8082/',
  // imageBaseUrl: 'http://58.220.10.222:19000/application',
  projectName: '协同管理系统'
}
